import { HttpErrorResponse } from '@angular/common/http';
import { Component, inject } from '@angular/core';
import { LifePlan, LifePlanDTO } from '../../../../core/models/lifeplan.interface';
import { FormBuilder, FormsModule, ReactiveFormsModule, Validators } from '@angular/forms';
import { LifeplanService } from '../../../../core/services/lifeplan/lifeplan';
import { LoadingService } from '../../../../core/services/loading/loading';
import { MatDialogRef } from '@angular/material/dialog';
import { ToastrService } from 'ngx-toastr';
import { FormUtils } from '../../../../shared/utils';
import { MatError, MatFormField, MatLabel } from '@angular/material/form-field';
import { MatInput } from '@angular/material/input';
import { MatIcon, MatIconModule } from '@angular/material/icon';

@Component({
  selector: 'app-lifeplan-form',
  imports: [
    MatFormField,
    ReactiveFormsModule,
    MatLabel,
    MatInput,
    MatError,
    MatIcon,
    MatIconModule,
    FormsModule,
  ],
  templateUrl: './lifeplan-form.html',
  styleUrl: './lifeplan-form.scss',
})
export class LifeplanForm {
  sector: string | null = null;
  errorMsg: string[] | null = null;
  lifeplanSelected: LifePlan | null = null;
  private formBuilder = inject(FormBuilder);

  constructor(
    private dialogRef: MatDialogRef<LifeplanForm>,
    private toastr: ToastrService,
    private serviceLifeplan: LifeplanService,
    private loadingService: LoadingService,
  ) {}

  ngOnInit(): void {
    this.serviceLifeplan.asyncErrorValidation$.subscribe((error) => {
      if (error) {
        this.errorMsg = FormUtils.parseErrorMsgs(error);
      }
    });

    this.serviceLifeplan.selectedlifeplan$.subscribe((lifeplan) => {
      if (lifeplan) {
        this.lifeplanSelected = lifeplan;
        this.lifeplanForm.patchValue({
          ...lifeplan,
        });
      }
    });
  }

  lifeplanForm = this.formBuilder.group({
    name: ['', [Validators.required, Validators.maxLength(256)]],
    code: ['', [Validators.required, Validators.maxLength(256)]],
  });

  closeDialog() {
    this.dialogRef.close();
  }

  saveLifeplan() {
    const payload = this.lifeplanForm.value as LifePlanDTO;
    if (this.lifeplanForm.status === 'VALID' && !this.sector) {
      this.loadingService.show(true);
      this.serviceLifeplan.createLifeplan(payload).subscribe({
        next: (lifeplan) => {
          this.loadingService.show(false);
          const msg = `El plan de vida ${lifeplan.name} fue CREADO correctamente!`;
          this.toastr.success(msg, 'Exitoso!', {
            progressBar: true,
            timeOut: 5000,
          });
          this.dialogRef.close();
        },
        error: ({}: HttpErrorResponse) => {
          if (this.errorMsg) {
            this.loadingService.show(false);
            this.toastr.error('Error: ' + this.errorMsg, undefined, {
              progressBar: true,
              timeOut: 5000,
            });
          }
        },
      });
    } else if (this.lifeplanForm.status === 'VALID' && this.sector) {
      this.loadingService.show(true);
      const id = Number(this.sector);
      this.serviceLifeplan.UpdateLifeplan(id, { ...payload, id: id }).subscribe({
        next: (lifeplan) => {
          this.loadingService.show(false);
          const msg = `El plan de vida ${lifeplan.name} fue EDITADO correctamente!`;
          this.toastr.success(msg, 'Exitoso!', {
            progressBar: true,
            timeOut: 5000,
          });
          this.dialogRef.close();
        },
        error: ({}: HttpErrorResponse) => {
          if (this.errorMsg) {
            this.loadingService.show(false);
            this.toastr.error('Error: ' + this.errorMsg, undefined, {
              progressBar: true,
              timeOut: 5000,
            });
          }
        },
      });
    }
  }
}
